document.addEventListener("DOMContentLoaded", () => {
  // run only on /pages/world-of-kyphie
  if (window.location.pathname.includes("/pages/world-of-kyphie")) {

    const wrappers = document.querySelectorAll(".image-with-text__wrapper");

    wrappers.forEach((wrapper, index) => {
    if (index !== 0) {
        wrapper.style.overflow = "visible";
    }
    });


    gsap.registerPlugin(ScrollTrigger);

    gsap.to(".image-with-text__image-wrapper img", {
      scale: 1.15,
      ease: "none",
      scrollTrigger: {
        trigger: ".hero-section",
        start: "top top",
        end: "bottom top",
        scrub: true
      }
    });
  }
});
